/* =============================================================================
   env - the library's environment flags, READ ONCE at module load.

   Exports one frozen-by-convention object `env` with four boot-time facts:
   `touch` (coarse pointer), `reducedMotion` (the user asked for reduced motion),
   `locale` (the <html lang> hint) and `rtl` (a constant false). The values are
   never polled and never re-read: a component that must react to a change
   (theme, locale, an orientation flip) listens for it instead of watching these.
   Every read is guarded, so the module is safe to import where there is no DOM.
   No dependencies.
   ============================================================================= */

export const env = {
  /** coarse pointer = touch-first device (mobile / TV panel) */
  touch: typeof matchMedia !== 'undefined' && matchMedia('(pointer: coarse)').matches,
  /** user asked for reduced motion - components skip their transitions when true */
  reducedMotion: typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion: reduce)').matches,
  /** boot locale hint taken from <html lang>; LocaleService is the authority afterwards */
  locale: (typeof document !== 'undefined' && document.documentElement.lang) || 'en',
  /** right-to-left flag: no supported locale is RTL, so this is a constant false
      kept as the seam layout code branches on */
  rtl: false,
};
